//@ts-nocheck
// src/pages/AuthValidation.tsx

import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../hooks/useAppDispatch';
import { useAppSelector } from '../hooks/useAppSelector';
import { RootState } from '../store';
import { createCandidateLogin, verifyCandidateOtp } from '../store/slices/jobAuth/JobAuthSlice';
import { ListboxButton, ListboxOption, ListboxOptions, Listbox } from '@headlessui/react'
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

interface EmailLoginFormProps {
  onSubmit: (email: string) => void;
  onBack: () => void;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}


const EmailLoginForm: React.FC<EmailLoginFormProps> = ({ onSubmit, onBack }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const dispatch = useAppDispatch();

  const { createCandidateStatus, createCandidateError } = useAppSelector((state: RootState) => state.jobauth);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);

    if (!emailRegex.test(value)) {
      setError('Please enter a valid email address');
    } else {
      setError('');
    }
  };


  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address');
      return; // Prevent submission
    }
    const result = await dispatch(createCandidateLogin({ payload: { email } })).unwrap();

    onSubmit(email);
  };





  return (
    <form
      onSubmit={handleSubmit}
      className="mt-[-0.6rem]">
      <label htmlFor="email" className="wg-label mb-2 capitalize inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5 font-medium">
        Email
      </label>
      <input
        type="text"
        value={email}
        onChange={handleChange}
        placeholder="Enter your email"
        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300
                 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-1 focus:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-gray-50
                  disabled:text-gray-500 disabled:outline-gray-200 sm:text-sm/6"
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}

      <div className='flex items-center justify-end mt-7'>
        {/* <button className=' text-[13px] text-[#266df0]'>
          Resend Otp
        </button> */}
        <button
          type="submit"
          className="group inline-flex shrink-0 select-none justify-center items-center px-[14px] py-1 text-[13px] font-medium h-[32px] 
                    leading-6 transition-colors duration-100 focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 
                     rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"

        >
          {createCandidateStatus === 'loading' ? (
            <div className='flex items-center justify-center gap-[8px]'>
              Send OTP
              <div className="simple-spinner">
                <span></span>
              </div>
            </div>
          ) : (
            'Send OTP'
          )}

        </button>
        {/* <button
                type="button"
                onClick={onBack}
                className="inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
            >
                Back
            </button> */}
      </div>
    </form>
  );
};

// components/Auth/OtpVerification.tsx
interface OtpVerificationProps {
  email: string;
  onSuccess: () => void;
  onBack: () => void;

}

const OtpVerification: React.FC<OtpVerificationProps> = ({
  email,
  onSuccess,
  onBack,

}) => {
  const [otp, setOtp] = useState<string[]>(Array(6).fill(''));
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const { verifyCandidateStatus, verifyCandidateError } = useAppSelector((state) => state.jobauth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate()
  const [resendCooldown, setResendCooldown] = useState(60); // Start with 60 seconds
  const [resendLoading, setResendLoading] = useState(false);

  useEffect(() => {
    // Focus the first input on component mount
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index: number, value: string) => {
    // Only allow numbers
    if (!/^\d*$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Auto focus next input
    if (value !== '' && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index: number, e: React.KeyboardEvent<HTMLInputElement>) => {
    // Handle backspace
    if (e.key === 'Backspace') {
      if (otp[index] === '' && index > 0) {
        const newOtp = [...otp];
        newOtp[index - 1] = '';
        setOtp(newOtp);
        inputRefs.current[index - 1]?.focus();
      } else {
        const newOtp = [...otp];
        newOtp[index] = '';
        setOtp(newOtp);
      }
    }
  };

  const handlePaste = (e: React.ClipboardEvent) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    const pastedNumbers = pastedData.replace(/[^\d]/g, '').split('').slice(0, 6);

    const newOtp = [...otp];
    pastedNumbers.forEach((num, index) => {
      if (index < 6) {
        newOtp[index] = num;
      }
    });
    setOtp(newOtp);

    // Focus last filled input or next empty input
    const focusIndex = Math.min(pastedNumbers.length, 5);
    inputRefs.current[focusIndex]?.focus();
  };

  // const handleSubmit = (e: React.FormEvent) => {
  //   e.preventDefault();
  //   const otpString = otp.join('');
  //   if (otpString.length === 6) {
  //     // Add your OTP verification logic here
  //     localStorage.setItem('token', 'your-auth-token');
  //     onSuccess();
  //   }
  // };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const otpString = otp.join('');

    if (otpString.length === 6) {
      try {
        const res = await dispatch(verifyCandidateOtp({
          payload: {
            email: email,
            otp: otpString
          }
        })).unwrap();
        if (res.status === 200) {
          localStorage.setItem('accessToken', res?.accessToken);
          localStorage.setItem('email', res?.candidate?.email);
          localStorage.setItem('name', res?.candidate.name)

          navigate('/applications')
          if (typeof onSuccess === 'function') {
            onSuccess();
          }


        }



      } catch (error) {
        console.error('OTP verification failed:', error);
      }
    }
  };

  useEffect(() => {
    let timer: number | null = null;

    // Start timer immediately when component mounts
    if (resendCooldown > 0) {
      timer = window.setInterval(() => {
        setResendCooldown(prevCooldown => prevCooldown - 1);
      }, 1000);
    }

    return () => {
      if (timer) window.clearInterval(timer);
    };
  }, [resendCooldown]);

  // Implement the handleResendOtp function
  const handleResendOtp = async () => {
    if (resendCooldown > 0) return; // Prevent resend if cooldown is active

    try {
      setResendLoading(true);

      // Call the same API endpoint that was used to send the original OTP
      const result = await dispatch(createCandidateLogin({ payload: { email } })).unwrap();

      // Reset cooldown to 60 seconds after successful API call
      setResendCooldown(60);

      // You could add a toast notification here if you have a toast library
      // toast.success("OTP resent successfully");
    } catch (error) {
      console.error('Failed to resend OTP:', error);
      // You could add an error toast here
      // toast.error("Failed to resend OTP");
    } finally {
      setResendLoading(false);
    }
  };


  return (
    <form id="otp-form" onSubmit={handleSubmit}>
      <div className="flex items-center justify-center gap-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <input
            key={index}
            ref={el => inputRefs.current[index] = el}
            type="text"
            value={otp[index]}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            className="w-10 h-10 lg:w-14 lg:h-14 text-center border-[#a9a9bc52] focus:border-[2px] focus:border-indigo-600 focus:border-solid border-[0.5px] text-2xl font-extrabold text-slate-900 bg-slate-100  hover:border-slate-200 appearance-none rounded-lg p-4 outline-none focus:bg-white focus:ring-0 focus:ring-indigo-600"
            maxLength={1}
          />
        ))}
      </div>
      <div className="max-w-[260px] mx-auto mt-10">
        <button
          type="submit"
          className="group w-full inline-flex shrink-0 select-none justify-center items-center px-[14px] py-1 text-[13px] font-medium h-[38px] 
                    leading-6 transition-colors duration-100 focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 
                     rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
          disabled={otp.join('').length !== 6}
        >
          {verifyCandidateStatus === 'loading' ? (
            <div className='flex items-center justify-center gap-[8px]'>
              Send OTP
              <div className="simple-spinner">
                <span></span>
              </div>
            </div>
          ) : (
            'Send OTP'
          )}
        </button>
      </div>
      <div className='flex items-center justify-center mt-7'>
        <button
          onClick={handleResendOtp}
          disabled={resendCooldown > 0 || resendLoading}
          className={`text-[13px] ${resendCooldown > 0 || resendLoading
            ? 'text-gray-400 cursor-not-allowed'
            : 'text-[#266df0] hover:text-[#1a5cd8]'
            }`}
        >
          {resendLoading ? (
            <div className='flex items-center justify-center gap-[8px]'>
              Sending...
              <div className="simple-spinner">
                <span></span>
              </div>
            </div>
          ) : resendCooldown > 0 ? (
            `Resend OTP (${resendCooldown}s)`
          ) : (
            'Resend OTP'
          )}
        </button>
      </div>
    </form>
    // <form onSubmit={handleSubmit} className="space-y-4">
    //     <input
    //         type="text"
    //         value={otp}
    //         onChange={(e) => setOtp(e.target.value)}
    //         placeholder="Enter OTP"
    //         className="w-full p-2 border rounded"
    //         maxLength={6}
    //         required
    //     />
    //     <button type="submit" className="w-full bg-primary text-white p-2 rounded">
    //         Verify
    //     </button>
    //     <button
    //         type="button"
    //         onClick={onBack}
    //         className="w-full bg-transparent text-gray-500 p-2"
    //     >
    //         Back
    //     </button>
    // </form>
  );
};

// components/Auth/GoogleLoginButton.tsx
interface GoogleLoginButtonProps {
  onSuccess: () => void;
}

const GoogleLoginButton: React.FC<GoogleLoginButtonProps> = ({ onSuccess }) => {
  const navigate = useNavigate()
  const [loadingGoogle, setLoadingGoogle] = useState(false); // ✅ loading state


  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: async (codeResponse) => {
      setLoadingGoogle(true); // start loading
      try {
        const res = await axios.post(
          'https://atsapi.teamer.app/v1/auth/google',
          { code: codeResponse.code },
          { withCredentials: true }
        );

        if (res.data?.status === 200) {
          localStorage.setItem('accessToken', res.data.data?.accessToken);
          localStorage.setItem('email', res.data.data?.candidate?.email);
          localStorage.setItem('name', res.data.data?.candidate?.name)
          navigate('/applications')
          if (typeof onSuccess === 'function') {
            onSuccess();
          }


        }
      } catch (err) {
        console.error('Login failed:', err);
      } finally {
        setLoadingGoogle(false); // stop loading
      }
    },
    onError: (errorResponse) => {
      console.error('Google login error:', errorResponse);
      setLoadingGoogle(false)
    },
  });

  return (
    <button
      onClick={() => login()}
      className="flex w-full items-center h-[40px] justify-center gap-3 rounded-md px-3 py-2 text-sm font-semibold text-gray-900 border border-solid border-[#e7e7e8]"
    >
      <svg
        stroke="currentColor"
        fill="currentColor"
        strokeWidth={0}
        viewBox="0 0 488 512"
        focusable="false"
        className=""
        aria-hidden="true"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z" />
      </svg>
      {loadingGoogle ? (
        <div className='flex items-center justify-center gap-[12px]'>
          Continue with Google
          <div className="simple-spinner">
            <span style={{ borderRightColor: '#20808d' }}></span>
          </div>
        </div>
      ) : (
        'Continue with Google'
      )}

    </button>
  );
};


const AuthValidation = ({ onLoginSuccess }) => {
  const [LoginLoading, SetLoginLoading] = useState(false)
  const [step, setStep] = useState<'initial' | 'email' | 'otp'>('initial');
  const [email, setEmail] = useState('');
  const [otpSaveDetails, setOtpSaveDetails] = useState('')
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      // User is already logged in, redirect to applications
      navigate('/applications', { replace: true });
      return;
    }
    // Get the email from localStorage
    const emailFromStorage = localStorage.getItem('email');
    if (emailFromStorage) {
      setOtpSaveDetails(emailFromStorage);
    }

    // Function to close dropdown when clicking outside
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    // Add event listener when dropdown is open
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, navigate]);




  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('email');
    localStorage.removeItem('name');
    window.location.reload();

  }


  return (



    <div className='bg-zinc-100'>
      <div className="relative isolate flex w-[calc(100%_-_2px)] flex-col bg-white lg:bg-zinc-100">
        <header className="flex items-center px-4 h-[56px]">
          <div className="min-w-0 flex-1 h-full">
            <nav className="flex flex-1 items-center gap-4 py-2.5">
              <div className="flex shrink-0 items-center px-[0rem] justify-between w-full">
                <Link className="" to="#">
                  <div className="flex gap-[0.5rem] items-center cursor-pointer h-[32px] px-[0rem] w-full">
                    <img
                      className="h-6 w-6 rounded-[5px]"
                      src="https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/public/assets/teamer-logo.png"
                      alt="base logo"
                    />
                    <span className="leading-[1.2] font-semibold whitespace-nowrap text-[0.8125rem] cursor-pointer truncate w-full max-w-[160px] min-w-[140px]
                     overflow-hidden text-ellipsis text-start ">
                      teamer
                    </span>
                    <div className="mx-[6px] w-[1px] h-6 bg-zinc-950/10  block" />
                  </div>
                </Link>

                {otpSaveDetails &&
                  <Listbox value={dropdownOpen} onChange={setDropdownOpen}>
                    {({ open }) => (
                      <div className="relative z-10 flex">
                        <ListboxButton className="relative w-auto min-w-[110px] flex items-center gap-[6px]  pl-3 py-[0px]   cursor-pointer">
                          <div className='flex items-center gap-1.5 justify-between hover:ring-1 ring-gray-200 p-1 rounded-md'>
                            <span className="block truncate text-[13px] font-medium text-gray-600">{otpSaveDetails}</span>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-3">
                              <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                            </svg>
                          </div>
                        </ListboxButton>

                        <ListboxOptions className="absolute z-10 mt-1 top-[32px] right-0 bg-white w-full overflow-hidden rounded-lg border border-gray-200 p-1 shadow-lg">
                          <ListboxOption
                            key="applicationlist"
                            value={true}

                            className={({ active }) =>
                              classNames(
                                active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                'relative flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-[6px]  text-[13px]   outline-none transition-colors'
                              )
                            }
                          >
                            <span className="block truncate font-normal leading-4">Application List</span>
                          </ListboxOption>

                          <ListboxOption
                            key="logout"
                            value={true}
                            onClick={handleLogout}
                            className={({ active }) =>
                              classNames(
                                active ? 'bg-gray-200 text-[#1d2025]' : 'text-gray-900',
                                'relative flex cursor-pointer select-none items-center gap-2 rounded-md px-2 py-[6px]  text-[13px]   outline-none transition-colors'
                              )
                            }
                          >
                            <span className="block truncate font-normal leading-4">Logout</span>
                          </ListboxOption>
                        </ListboxOptions>
                      </div>
                    )}
                  </Listbox>
                }
              </div>
            </nav>
          </div>
        </header>
      </div>
      <main className="flex flex-1 flex-col pb-2 lg:px-2  h-[calc(100vh_-_56px)]">
        <div className="grow p-6 rounded-lg bg-white lg:p-0 ring-1 ring-zinc-950/5 shadow-xs h-full">
          <div className="w-full flex items-center flex-wrap lg:flex-nowrap h-full overflow-auto">
            <div className="w-full lg:w-[50%] h-full">
              <div className="flex min-h-full items-center flex-1 flex-col justify-center max-w-[487px] m-auto px-4 py-5">
                <div className="w-full bg-white py-0 rounded-md mt-0 lg:mt-0 mb-[0rem]">
                  <div className="mb-10 ml-0">
                    <h2 className="text-left font-medium leading-5 text-dark-black-100 text-[16px]">
                      {step === 'initial' && 'Login to teamer'}
                      {step === 'email' && 'Enter Your Email'}
                      {step === 'otp' && 'Enter Your OTP'}
                    </h2>
                  </div>
                  <div>
                    {step === 'initial' && (
                      <div className="space-y-4">
                        <GoogleLoginButton onSuccess={onLoginSuccess} />
                        <div className="relative">
                          <div className="absolute inset-0 flex items-center">
                            <span className="w-full border-t" />
                          </div>
                          <div className="relative flex justify-center">
                            <span className="bg-white px-2 text-dark-black-200">Or continue with</span>
                          </div>
                        </div>
                        <button
                          onClick={() => setStep('email')}
                          className=" w-full group inline-flex shrink-0 select-none justify-center items-center px-[14px] py-1 text-[13px] font-medium h-[38px] 
                                                    leading-6 transition-colors duration-100 focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 
                                                     rounded-md text-white bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600"
                        >
                          Continue with Email
                        </button>
                      </div>
                    )}
                    {step === 'email' && (
                      <EmailLoginForm
                        onSubmit={(email) => {
                          setEmail(email);
                          setStep('otp');
                        }}
                        onBack={() => setStep('initial')}
                      />
                    )}
                    {step === 'otp' && (
                      <OtpVerification
                        email={email}
                        onSuccess={onLoginSuccess}
                        onBack={() => setStep('email')}

                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-[50%] h-[50%] md:h-full lg:h-full">
              <img
                src="https://pub-d78e6f485da34d3b9d6618927284f469.r2.dev/public/assets/teamerimage.png"
                alt=""
                className="w-full h-full rounded-tr-lg rounded-br-lg"
              />
            </div>
          </div>
        </div>
      </main>
    </div>

  );
};

export default AuthValidation;
